<template>
  <div class="basic-info">
    <div class="basic-info-container">
      <el-form
        :model="form"
        ref="form"
        label-width="auto"
        size="mini"
        :rules="formRules"
        :disabled="formDisabled || mode === 'view'"
      >
        <div class="form-scroll-container">
          <!-- ===== 第一行 ===== -->
          <el-row :gutter="8" class="form-row">
            <el-col :span="6">
              <el-form-item
                label="厂商名称："
                prop="manufacturerName"
                :rules="[{ required: true, message: '请输入厂商名称', trigger: 'blur' }]"
                class="form-item-compact form-item-adaptive required-field-item"
              >
                <el-input v-model="form.manufacturerName" placeholder="请输入厂商名称" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产地：" prop="origin" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.origin" placeholder="请输入产地" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系人：" prop="contacts" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.contacts" placeholder="请输入联系人" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系电话：" prop="contactNumber" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.contactNumber" placeholder="请输入联系电话" clearable class="compact-input" />
              </el-form-item>
            </el-col>
          </el-row>
          
          <!-- ===== 第二行 ===== -->
          <el-row :gutter="8" class="form-row">
            <el-col :span="6">
              <el-form-item label="gmp证书号：" prop="gmp" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.gmp" placeholder="请输入gmp证书号" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="gmp证书效期：" prop="gmpPeriod" class="form-item-compact form-item-adaptive">
                <el-date-picker
                  v-model="form.gmpPeriod"
                  type="date"
                  placeholder="选择gmp证书有效期"
                  value-format="yyyy-MM-dd"
                  clearable
                  class="compact-datepicker"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="营业执照：" prop="businessLicense" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.businessLicense" placeholder="请输入营业执照" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="执照效期：" prop="businessLicensePeriod" class="form-item-compact form-item-adaptive">
                <el-date-picker
                  v-model="form.businessLicensePeriod"
                  type="date"
                  placeholder="选择执照效期"
                  value-format="yyyy-MM-dd"
                  clearable
                  class="compact-datepicker"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- ===== 第三行 ===== -->
          <el-row :gutter="8" class="form-row">
            <el-col :span="6">
              <el-form-item label="卫生许可证：" prop="hygienicLicense" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.hygienicLicense" placeholder="请输入卫生许可证" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="卫生有效期：" prop="hygieneValidityPeriod" class="form-item-compact form-item-adaptive">
                <el-date-picker
                  v-model="form.hygieneValidityPeriod"
                  type="date"
                  placeholder="选择卫生有效期"
                  value-format="yyyy-MM-dd"
                  clearable
                  class="compact-datepicker"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="邮箱：" prop="email" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.email" placeholder="请输入邮箱" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="传真：" prop="fax" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.fax" placeholder="请输入传真" clearable class="compact-input" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- ===== 第四行 ===== -->
          <el-row :gutter="8" class="form-row">
            <el-col :span="6">
              <el-form-item label="邮政编码：" prop="postalCode" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.postalCode" placeholder="请输入邮政编码" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属地域：" prop="region" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.region" placeholder="请输入所属地域" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="社会信用代码：" prop="creditCode" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.creditCode" placeholder="请输入统一社会信用代码" clearable class="compact-input" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- ===== 第五行 ===== -->
          <el-row :gutter="8" class="form-row">
            <el-col :span="6">
              <el-form-item label="可用状态：" prop="status" class="form-item-compact form-item-adaptive status-item">
                <el-switch
                  v-model="form.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产许可证：" prop="productionLicense" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.productionLicense" placeholder="请输入生产许可证" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产有效期：" prop="productionValidityPeriod" class="form-item-compact form-item-adaptive">
                <el-date-picker
                  v-model="form.productionValidityPeriod"
                  type="date"
                  placeholder="选择生产有效期"
                  value-format="yyyy-MM-dd"
                  clearable
                  class="compact-datepicker"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="有效期：" prop="periodValidity" class="form-item-compact form-item-adaptive">
                <el-date-picker
                  v-model="form.periodValidity"
                  type="date"
                  placeholder="选择有效期"
                  value-format="yyyy-MM-dd"
                  clearable
                  class="compact-datepicker"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- ===== 第六行 ===== -->
          <el-row :gutter="8" class="form-row">
            <el-col :span="6">
              <el-form-item label="适用对象：" prop="applicableObject" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.applicableObject" placeholder="请输入适用对象" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="网址：" prop="url" class="form-item-compact form-item-adaptive">
                <div class="url-input-group">
                  <span class="url-prefix">https://</span>
                  <el-input v-model="form.url" placeholder="请输入网址" clearable class="compact-input" />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="备注：" prop="remake" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.remake" placeholder="请输入备注" clearable class="compact-input" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicInfo',
  props: {
    form: { type: Object, required: true },
    formDisabled: { type: Boolean, default: false },
    mode: { type: String, default: 'add' },
    fieldConfig: { type: Array, default: () => [] }
  },
  data() {
    return {
      formRules: {}
    };
  },
  methods: {
    updateForm() {
      this.$emit('update', this.form);
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
    enableFormValidation() {},
    async validateForm() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          this.$refs.form.validate((valid) => {
            if (valid) resolve();
            else reject(new Error('表单验证失败'));
          });
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.basic-info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .basic-info-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;

    .el-form {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;

      .form-scroll-container {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 60px 16px 8px 16px;
        box-sizing: border-box;

        &::-webkit-scrollbar { width: 8px; height: 8px; }
        &::-webkit-scrollbar-track { background: #f5f5f5; border-radius: 4px; }
        &::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 4px; }
        &::-webkit-scrollbar-thumb:hover { background: #a8a8a8; }

        .form-row {
          .el-col {
            padding-bottom: 12px;
            
            .form-item-compact {
              margin-bottom: 0;
              display: flex;
              align-items: stretch;

              /* 使用 ::v-deep 限定在本组件内部生效 */
              ::v-deep .el-form-item__label {
                background-color: #f5f7fa;
                border: 1px solid #dcdfe6;
                border-right: none;
                padding: 0 8px;
                line-height: 34px;
                height: 36px;
                font-weight: bold;
                color: #00557f;
                width: auto;
                min-width: 90px;
                max-width: 130px;
                text-align: left;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-size: 12px;
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
                white-space: normal;
                word-break: break-word;
                flex-shrink: 0;
              }

              ::v-deep .el-form-item__content {
                border: 1px solid #dcdfe6;
                border-left: none;
                line-height: 34px;
                height: 36px;
                flex: 1;
                margin-left: 0 !important;
                display: flex;
                align-items: center;
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                overflow: hidden;
                
                .compact-input,
                .compact-datepicker {
                  width: 100%;
                  height: 100%;
                  
                  .el-input__inner {
                    border: none !important;
                    height: 100%;
                    line-height: 34px;
                    padding: 0 8px;
                    font-size: 12px;
                    color: #606266;
                    text-align: left;
                  }
                  .el-input__icon {
                    line-height: 34px;
                  }
                }
              }
            }

            /* 状态栏无外框 */
            .status-item {
              ::v-deep .el-form-item__content {
                border: none;
                padding-left: 10px;
              }
            }

            /* 网址组合框 */
            .url-input-group {
              display: flex;
              align-items: center;
              width: 100%;
              height: 100%;
              .url-prefix {
                background: #f5f7fa;
                border-right: 1px solid #dcdfe6;
                padding: 0 8px;
                height: 100%;
                line-height: 34px;
                font-size: 12px;
                color: #909399;
                white-space: nowrap;
              }
              .compact-input {
                flex: 1;
                width: auto;
              }
            }
          }
        }
      }
    }
  }
}

::v-deep .required-field-item .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>